import React from 'react';
import { ApplicationView, useController } from '@aha-app/mvc';
import styles from './HeaderPanel.module.css';
import type AssistantViewController from '../AssistantView/AssistantViewController';
import classNames from 'classnames';
import fullHeightSvg from '../../assets/icons/fullHeight.svg';
import fullScreenSvg from '../../assets/icons/fullScreen.svg';
import toolbarSvg from '../../assets/icons/toolbar.svg';

const HeaderButtons = () => {
  const controller = useController<AssistantViewController>();
  const { dock, model, size } = controller.state;
  const isFullPage = size === 'full-page';

  return (
    <div
      className={classNames(styles.headerButtons, {
        [styles.headerButtonsFullScreen]: isFullPage,
      })}
    >
      {size !== 'toolbar' && !model.emptyChat && (
        <>
          <aha-button
            kind='icon'
            size='mini'
            onClick={() => controller.actionNewChat()}
          >
            <i className='far fa-circle-plus' />
          </aha-button>
          <aha-tooltip style={{ '--Tooltip__tooltip--min-width': 0 }}>
            New chat
          </aha-tooltip>
        </>
      )}
      <aha-button
        kind='icon'
        size='mini'
        onClick={() => controller.actionShowToolPanel('history')}
      >
        <i className='far fa-clock-three' />
      </aha-button>
      <aha-tooltip style={{ '--Tooltip__tooltip--min-width': 0 }}>
        History
      </aha-tooltip>
      {!['toolbar', 'full-page', 'full-screen'].includes(size) && (
        <>
          <aha-button
            kind='icon'
            size='mini'
            onClick={() => controller.actionResizeByTrigger('full-screen')}
          >
            <img src={fullScreenSvg} />
          </aha-button>
          <aha-tooltip style={{ '--Tooltip__tooltip--min-width': 0 }}>
            Full screen
          </aha-tooltip>
        </>
      )}
      {['full-screen', 'toolbar'].includes(size) && (
        <>
          <aha-button
            kind='icon'
            size='mini'
            onClick={() => controller.actionResizeByTrigger('full-height')}
          >
            <img src={fullHeightSvg} />
          </aha-button>
          <aha-tooltip style={{ '--Tooltip__tooltip--min-width': 0 }}>
            Full height
          </aha-tooltip>
        </>
      )}
      {!['full-page', 'toolbar'].includes(size) &&
        !['side-panel'].includes(dock) && (
          <>
            <aha-button
              kind='icon'
              size='mini'
              onClick={() => controller.actionResizeByTrigger('toolbar')}
            >
              <img src={toolbarSvg} />
            </aha-button>
            <aha-tooltip style={{ '--Tooltip__tooltip--min-width': 0 }}>
              Reduce
            </aha-tooltip>
          </>
        )}
      {['toolbar', 'full-height', 'engaged-bottom', 'engaged-top'].includes(
        size
      ) && (
        <>
          <aha-button
            kind='icon'
            size='mini'
            onClick={() => controller.actionClose()}
          >
            <i className='far fa-xmark' />
          </aha-button>
          <aha-tooltip style={{ '--Tooltip__tooltip--min-width': 0 }}>
            Close
          </aha-tooltip>
        </>
      )}
    </div>
  );
};

export default ApplicationView(HeaderButtons);
